<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="humax"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Lembur Pegawai
                    </span>
                  </div>

                  <v-spacer />
                  
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0 pr-1">
            <v-col
              cols="4"
              class="pt-0">
              <v-tabs 
                v-model="selected.menu"
                flat
                grow
                slider-size="5"
                :color="set_color"
                style="border-radius: 10px !important;">
                <v-tab
                  class="d-flex justify-start"
                  v-for="(item, index) in menu"
                  :key="index"
                  style="min-width: 70px; border-radius: 10px !important; background-color: #f9f9f9;">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="18">
                      <v-img
                        contain
                        alt="humax"  
                        :src="item.icon">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="text-capitalize ml-2"
                      :class="selected.menu === index ? 'font-weight-bold' : ''">
                      {{ item.text }}
                    </span>
                  </div>
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>

          <Ajuan v-if="selected.menu === 0" />

          <Riwayat v-if="selected.menu === 1" />
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },

        menu: [
          {
            text: 'Ajuan Lembur',
            icon: require('@/assets/icon/tab/ajuan_lembur.png')
          },
          {
            text: 'Riwayat Lembur',
            icon: require('@/assets/icon/tab/riwayat_lembur.png')
          }
        ],

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Ajuan: () => import(/* webpackPrefetch: true */ '@/views/private/overtime/proposal/index.vue'),
      Riwayat: () => import(/* webpackPrefetch: true */ '@/views/private/overtime/history/index.vue')
    },
    watch: {
      
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      
    }
  }
</script>